export default __webpack_public_path__ + "static/media/CIA-Claim-Form.f2d2ad12.pdf";